import {
  TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_BEGIN,
  TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_SUCCESS,
  TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_FAILURE,
  TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function fetchAllMailTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_BEGIN,
    });

    const { projectId, version } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=EMAIL`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAllMailTemplateError() {
  return {
    type: TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_BEGIN:
      return {
        ...state,
        fetchAllMailTemplatePending: true,
        fetchAllMailTemplateError: null,
      };

    case TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchAllMailTemplatePending: false,
        fetchAllMailTemplateError: null,
        mailTemplates: action.data,
      };

    case TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchAllMailTemplatePending: false,
        fetchAllMailTemplateError: action.data.error,
      };

    case TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        fetchAllMailTemplateError: null,
      };

    default:
      return state;
  }
}
